import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const WarningIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 7C12.5523 7 13 7.44772 13 8V12.5C13 13.0523 12.5523 13.5 12 13.5C11.4477 13.5 11 13.0523 11 12.5V8C11 7.44772 11.4477 7 12 7ZM12 14.9688C12.5523 14.9688 13 15.4165 13 15.9688V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V15.9688C11 15.4165 11.4477 14.9688 12 14.9688Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

WarningIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(WarningIcon);
